/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 23/12/21
 */

import { useStatefulRequestWithData } from '@/utils/useStatefulRequests/useStatefulRequestWithData';
import { UseStatefulRequestOptions } from '@/utils/useStatefulRequests/useStatefulRequest';

export const usePutRequest = <ResponseData, RequestData = never>(options?: UseStatefulRequestOptions) => {
    return useStatefulRequestWithData<ResponseData, RequestData>('PUT', options);
};
